import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceTypes', ['cachedTypes', 'selectedType']),
}

export const Methods = mapActions('deviceTypes', [
  'selectType',
  'fetchTypes',
  'updateType',
])
